module.exports = __webpack_public_path__ + "img/08848231000242.712361d0.png";